import { render, staticRenderFns } from "./ChatMessageAudio.vue?vue&type=template&id=e2dda024&scoped=true&"
import script from "./ChatMessageAudio.vue?vue&type=script&lang=js&"
export * from "./ChatMessageAudio.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageAudio.vue?vue&type=style&index=0&id=e2dda024&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dda024",
  null
  
)

export default component.exports